__turbopack_context__.v({
  "pagination-container": "uh5Q1W_pagination-container",
  "section": "uh5Q1W_section",
  "section__primary-content": "uh5Q1W_section__primary-content",
  "section__secondary-content": "uh5Q1W_section__secondary-content",
  "section__title": "uh5Q1W_section__title",
  "sections-container": "uh5Q1W_sections-container",
});
